<div
  *ngIf="show"
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/10 backdrop-blur-sm"
>
  <div class="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl border border-gray-200">
    <h2 class="text-xl font-semibold text-gray-900 mb-4">Refund Transaction</h2>

    <!-- Transaction Info -->
    <div class="mb-5 bg-gray-50 p-4 rounded-lg text-sm text-gray-800 border space-y-1">
      <div><span class="font-medium">ID:</span> {{ transaction.uuid }}</div>
      <div><span class="font-medium">Date:</span> {{ transaction.created_at | date:'dd/MM/yyyy HH:mm' }}</div>
      <div>
        <span class="font-medium">User:</span>
        <span *ngIf="transaction.user">
          {{ transaction.user.first_name }} {{ transaction.user.last_name }}
          <span class="text-xs text-gray-500">( {{ transaction.user.email }} )</span>
        </span>
      </div>
      <div><span class="font-medium">Amount:</span> ${{ transaction.amount }}</div>
      <div><span class="font-medium">Fees:</span> ${{ transaction.fees }}</div>
      <div><span class="font-medium">Type:</span> {{ transaction.transaction_type }}</div>
      <div><span class="font-medium">Status:</span> {{ transaction.status }}</div>
      <div><span class="font-medium">Accounting Type:</span> {{ transaction.accounting_type }}</div>
    </div>

    <!-- Refund Type -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1">Refund Type</label>
      <select
        [(ngModel)]="refundType"
        class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
      >
        <option value="full">Full Refund</option>
        <option value="partial">Partial Refund</option>
      </select>
    </div>

    <!-- Partial Amount Input -->
    <div *ngIf="refundType === 'partial'" class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1">Amount</label>
      <input
        type="number"
        [(ngModel)]="partialAmount"
        min="0.01"
        [max]="transaction.amount"
        (input)="checkPartialAmount()"
        placeholder="Enter refund amount"
        class="w-full border px-3 py-2 rounded-md text-sm shadow-sm focus:outline-none"
        [ngClass]="{
          'border-red-500': isInvalidAmount,
          'border-gray-300': !isInvalidAmount
        }"
      />
      <p *ngIf="isInvalidAmount" class="text-red-600 text-sm mt-1">
        Amount must be less than or equal to ${{ transaction.amount }}
      </p>
    </div>

    <!-- Actions -->
    <div class="flex justify-end space-x-2 pt-2">
      <button
        type="button"
        (click)="close.emit()"
        [disabled]="loading"
        class="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="submit()"
        [disabled]="loading || (refundType === 'partial' && isInvalidAmount)"
        class="inline-flex items-center bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg *ngIf="loading" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
        </svg>
        {{ loading ? 'Refunding...' : 'Confirm' }}
      </button>
    </div>
  </div>
</div>
